module.exports = "query chancelleryLocations{chancelleryLocations{list{id name address{city zip street}eConsult{active}}}}"